import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Dialog, Button } from "@graphiql/react";
import { useCollectionsStore } from "../store.js";
function updatedAtHint(incoming, current) {
  const diffMs = incoming - current;
  if (Math.abs(diffMs) < 6e4) {
    return "same time";
  }
  const diffMin = Math.round(Math.abs(diffMs) / 6e4);
  const diffHr = Math.round(Math.abs(diffMs) / 36e5);
  const diffDays = Math.round(Math.abs(diffMs) / 864e5);
  let magnitude;
  if (diffDays >= 1) {
    magnitude = `${diffDays}d`;
  } else if (diffHr >= 1) {
    magnitude = `${diffHr}h`;
  } else {
    magnitude = `${diffMin}m`;
  }
  return diffMs > 0 ? `theirs: ${magnitude} newer` : `theirs: ${magnitude} older`;
}
const ReviewRow = ({
  conflict,
  checked,
  onChange,
  collectionName
}) => {
  const hint = updatedAtHint(
    conflict.incoming.updatedAt,
    conflict.current.updatedAt
  );
  return /* @__PURE__ */ jsxs("label", { className: "graphiql-conflict-review-row", children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "checkbox",
        checked,
        onChange: (e) => onChange(conflict.incoming.id, e.target.checked),
        className: "graphiql-conflict-review-checkbox"
      }
    ),
    /* @__PURE__ */ jsx("span", { className: "graphiql-conflict-review-name", children: conflict.incoming.name }),
    collectionName && /* @__PURE__ */ jsxs("span", { className: "graphiql-conflict-review-collection", children: [
      "in ",
      collectionName
    ] }),
    /* @__PURE__ */ jsx("span", { className: "graphiql-conflict-review-hint", children: hint })
  ] });
};
const ConflictDialog = ({
  analysis,
  sourceLabel,
  open,
  onClose,
  onResolve
}) => {
  const [reviewing, setReviewing] = useState(false);
  const [checked, setChecked] = useState(/* @__PURE__ */ new Set());
  const localCollections = useCollectionsStore((s) => s.collections);
  const handleCheckChange = (id, isChecked) => {
    setChecked((prev) => {
      const next = new Set(prev);
      if (isChecked) {
        next.add(id);
      } else {
        next.delete(id);
      }
      return next;
    });
  };
  const handleOpenChange = (isOpen) => {
    if (!isOpen) {
      onClose();
    }
  };
  const collectionNameById = new Map(localCollections.map((c) => [c.id, c.name]));
  const summary = [
    analysis.newItems.length > 0 && `${analysis.newItems.length} new`,
    analysis.changedItems.length > 0 && `${analysis.changedItems.length} with changes`,
    analysis.unchangedCount > 0 && `${analysis.unchangedCount} unchanged`
  ].filter(Boolean).join(", ");
  const newCollectionCount = analysis.newCollections.length;
  return /* @__PURE__ */ jsxs(Dialog, { open, onOpenChange: handleOpenChange, children: [
    /* @__PURE__ */ jsx(Dialog.Header, { children: "Import conflicts" }),
    /* @__PURE__ */ jsxs(Dialog.Body, { children: [
      /* @__PURE__ */ jsxs("p", { className: "graphiql-conflict-summary", children: [
        "Importing ",
        /* @__PURE__ */ jsx("strong", { children: sourceLabel }),
        ": ",
        summary,
        " operation",
        analysis.newItems.length + analysis.changedItems.length + analysis.unchangedCount !== 1 ? "s" : "",
        newCollectionCount > 0 && `, ${newCollectionCount} new collection${newCollectionCount !== 1 ? "s" : ""}`,
        "."
      ] }),
      !reviewing ? /* @__PURE__ */ jsxs("div", { className: "graphiql-conflict-actions", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            type: "button",
            variant: "primary",
            onClick: () => onResolve({ mode: "merge", applyChanges: true }),
            children: "Apply changes"
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            type: "button",
            onClick: () => onResolve({ mode: "merge", applyChanges: false }),
            children: "Keep my versions"
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            type: "button",
            onClick: () => {
              setChecked(/* @__PURE__ */ new Set());
              setReviewing(true);
            },
            children: "Review each…"
          }
        )
      ] }) : /* @__PURE__ */ jsxs("div", { className: "graphiql-conflict-review", children: [
        /* @__PURE__ */ jsx("p", { className: "graphiql-conflict-review-hint-label", children: "Check which incoming versions to accept (unchecked = keep yours):" }),
        /* @__PURE__ */ jsx("div", { className: "graphiql-conflict-review-list", children: analysis.changedItems.map((conflict) => /* @__PURE__ */ jsx(
          ReviewRow,
          {
            conflict,
            checked: checked.has(conflict.incoming.id),
            onChange: handleCheckChange,
            collectionName: collectionNameById.get(
              conflict.currentCollectionId
            )
          },
          conflict.incoming.id
        )) }),
        /* @__PURE__ */ jsxs("div", { className: "graphiql-conflict-review-confirm", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              type: "button",
              variant: "primary",
              onClick: () => onResolve({ mode: "merge", changedItemIds: new Set(checked) }),
              children: "Confirm selection"
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              type: "button",
              onClick: () => {
                setReviewing(false);
                setChecked(/* @__PURE__ */ new Set());
              },
              children: "Back"
            }
          )
        ] })
      ] })
    ] })
  ] });
};
export {
  ConflictDialog
};
//# sourceMappingURL=conflict-dialog.js.map
